export const environment = {
  production: false,
  baseUrl: '/Testing',
  nodeUrl: '/Testing',
  cognitoUrl:
    'https://us-east-1zttv3px6a.auth.us-east-1.amazoncognito.com/oauth2/authorize?client_id=2ve3hkhr65516dnoeq57ro9r88&response_type=code&scope=aws.cognito.signin.user.admin&redirect_uri=' + window.location.origin.toString() + '/login',
  sso: 'RutgersTestIDp',
  region: 'us-east-1',
  clientId: '2ve3hkhr65516dnoeq57ro9r88',
  clientSecret: 'ggt7uitc50riuh07p3hu304phqf3590h2sj658qfl9r76e9te9d',
  domain: 'us-east-1zttv3px6a.auth',
  scope: 'aws.cognito.signin.user.admin',
  __auth_email: null,
};
